import React, { useEffect } from "react";
import LoginErrMsg from "../../../login/generic/loginErrMsg";
import InputField from "../../../generic/inputField";
import EdButton from "../../../generic/edButton";
import { betweenNChars, checkPasswordStranth } from "../../../utils/regex";
import ConfirmPassword from "../../../generic/confirmPassword";
import { passwordHints } from "../../../../Containers/Constants/commenFeatures";

export interface VSetPasswordFormProps {
  disableForm: boolean; // used to disable/enable form from parent
  errorMsg?: string; // error message that came from api
  resetForm: any; // reset password form
  onChange: (value: string) => void; // reset password form
  onSubmit: () => void; // function to be called on submit
  onRemoveError: () => void; // removes the errorMsg
}
const SetPasswordForm: React.FC<VSetPasswordFormProps> = (props) => {
  const [setPasswordFormErr, setSetPasswordFormErr] = React.useState({
    otp: "",
    password: "",
    confirmPassword: "",
  });

  // const [showPassword, setShowPassword] = React.useState({
  //   password: false,
  //   confirmPassword: false,
  // });
  const [showPasswordHint, setShowPasswordHint] = React.useState<Array<string>>(
    []
  );

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.onSubmit();
  };

  useEffect(() => {
    let listOfStr: Array<string> = [];
    let getStrength;
    if (props.resetForm.password.length === 0) {
      getStrength = passwordHints;
    } else {
      getStrength = checkPasswordStranth(
        6,
        12,
        props.resetForm.password,
        props.resetForm.email
      );
    }
    for (let list in getStrength) {
      if (getStrength[list] !== "") {
        listOfStr.push(getStrength[list]);
      }
    }

    setShowPasswordHint(listOfStr);
  }, [props.resetForm.password]);

  useEffect(() => {
    if (showPasswordHint.length === 0 || !props.resetForm.password) {
      setSetPasswordFormErr({
        ...setPasswordFormErr,
        password: "",
      });
    }
  }, [showPasswordHint]);

  useEffect(() => {
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }, [props.resetForm]);

  return (
    <div className="login_form loginid_form">
      <form onSubmit={handleSubmit} className="mg-b60">
        <div className="forgotPassword_head">
          <h3>Reset Password </h3>
          <p>Please enter the details to reset password</p>
        </div>
        <label className="inp_lbl mg-b5 ib">Enter OTP</label>
        <InputField
          id="otp"
          type="tel"
          integer
          pattern={betweenNChars(6)}
          defaultValue={props.resetForm.otp}
          onChange={(otp) => props.onChange({ ...props.resetForm, otp })}
          onBlur={(error) =>
            setSetPasswordFormErr({
              ...setPasswordFormErr,
              otp: error.pattern ? "" : "Please enter a valid otp",
            })
          }
          className="login_inp mg-b40"
          placeholder="Eg:5678987"
          errorText={setPasswordFormErr.otp}
          maxLength={6}
          autoComplete="off"
        />
        <ConfirmPassword
          form={props.resetForm}
          error={setPasswordFormErr}
          setError={setSetPasswordFormErr}
          onChange={props.onChange}
          showPasswordHint={showPasswordHint}
        />
        {/* <label className="inp_lbl mg-b5 ib">Set Password</label>
        <InputField
          defaultValue={props.resetForm.password}
          id="password"
          type={showPassword.password ? "text" : "password"}
          onChange={(password) =>
            props.onChange({ ...props.resetForm, password })
          }
          onBlur={() => {}}
          className="login_inp  focus"
          placeholder="Eg:5678987"
          errorText={setPasswordFormErr.password}
          suffix={
            <i
              className={`edel-icon-eye${
                showPassword.password ? "-cross" : ""
              } icon`}
              onClick={() =>
                setShowPassword({
                  ...showPassword,
                  password: !showPassword.password,
                })
              }
            />
          }
        />

        <ul className="Password-hints">
          <li>Password length should be between 6-12 characters</li>
          <li>At least one alphanumeric/special character</li>
          <li>
            <span>Special characters not allowed are</span>
            <p>
              {`(   ) > <  ?`} , % - + : ; [ ] {} | ~ ` ^ _ “ / ₹
            </p>
          </li>
        </ul>
        <label className="inp_lbl mg-b5 ib">Confirm Password</label>
        <InputField
          id="password"
          getValue
          defaultValue={props.resetForm.confirmPassword}
          type={showPassword.confirmPassword ? "text" : "password"}
          onChange={(confirmPassword) =>
            props.onChange({ ...props.resetForm, confirmPassword })
          }
          onBlur={(error) => {
            console.log(error);
            setSetPasswordFormErr({
              ...setPasswordFormErr,
              confirmPassword:
                error.value === props.resetForm.password
                  ? ""
                  : "Password and confirm password are not match",
            });
          }}
          className="login_inp mg-b40 focus"
          placeholder="Eg:5678987"
          errorText={setPasswordFormErr.confirmPassword}
          suffix={
            <i
              className={`edel-icon-eye${
                showPassword.confirmPassword ? "-cross" : ""
              } icon`}
              onClick={() =>
                setShowPassword({
                  ...showPassword,
                  confirmPassword: !showPassword.confirmPassword,
                })
              }
            />
          }
        /> */}

        {/* Show error if any */}
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}

        {/* Disable button if username or password is blank or form is disabled from outside */}
        <EdButton
          value="Reset Password"
          btnTyp="primary"
          className="submit_btn"
          disabled={
            props.disableForm ||
            Object.values(setPasswordFormErr).some((error) => error) ||
            Object.values(props.resetForm).some((value) => !value)
          }
        />
      </form>
    </div>
  );
};

export default SetPasswordForm;
